<template>
  <div class="md-card">
    <div class="text-primary regular" style="font-size:18px;margin-left:5px;margin-top:10px">
      <md-icon style="margin-left:-4px" class="text-primary">{{item.icon | icon}}</md-icon>
      {{item.description.topic}}
    </div>

    <div
      style="font-size:14px;margin-top:20px"
      class="text-gray regular"
      v-if="agendaSettings.showTime"
    >
      <md-icon>schedule</md-icon>
      {{item.startDate | moment("HH:mm")}} - {{item.endDate | moment("HH:mm")}}
    </div>

    <div class="md-layout md-layout-item md-size-100" v-if="item.showDetails">
      <div class="ml-auto">
        <md-button
          @click.prevent="$emit('showDetails')"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 10px"
        >{{$t('Go to details')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";

export default {
  props: ["item"],
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    })
  },

  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped >
.md-card {
  padding: 10px;
  margin: 20px 0px 20px 0px;
  background: #ffffff;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 15px;
  opacity: 1;
}

.md-card .md-card-content {
  padding: 0px;
  line-height: inherit;
}

.md-collapse-content p {
  margin-bottom: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>